import firebase from 'firebase';
import { fbApp } from './firebase';

const storage = fbApp.storage();

export default storage;
